import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import ReactSelect from '../../Shared/ReactSelect/ReactSelect';
import CustomTooltip from '../../Shared/CustomToolTip/CustomTooltip';
import infoIcon from './images/info.svg';
import logOutIcon from './images/logout.svg';
import './FlightManagerSelector.scss';

/**
 * FlightManagerSelector Component
 * Displays the flight manager selection dropdown with label and tooltip
 */
function FlightManagerSelector({
  flightManager,
  availableMembers = [],
  isOtpMode = false,
  readOnly = false,
  contactNumber,
  onFlightManagerChange,
  showLogoutButton = true,
  onLogout,
  children,
  inPopup = false
}) {
  // Create options for flight manager dropdown
  const flightManagerOptions = availableMembers.length > 0
    ? availableMembers.map(member => ({
      value: member.id,
      label: member.phone,
      member: member
    }))
    : [];

  const handleFlightManagerChange = (selectedOption) => {
    if (onFlightManagerChange) {
      onFlightManagerChange(selectedOption.member);
    }
  };

  const currentValue = flightManager
    ? flightManagerOptions.find(opt => opt.value === flightManager.id)
    : null;

  // Fixed position for popup context
  const tooltipFixedPosition = inPopup ? {
    arrowOffset: 48.5,
    top: 49.391,
    left: 28,
    placement: 'top'
  } : null;

  return (
    <>
      <div className="flight-manager-row">
        <span className="flight-manager-label">
          מנהל הטיסה
          <CustomTooltip
            placement="top"
            content='מנהל הטיסה יוכל להזיז, לבטל ולשנות את המנויים בחבילה'
            fixedPosition={tooltipFixedPosition}
          >
            <span className="info-icon">
              <Image src={infoIcon} alt="info" />
            </span>
          </CustomTooltip>
        </span>

        {(isOtpMode || readOnly || availableMembers.length == 1) ? (
          <div className="flight-manager-static-display">
            {currentValue?.value || flightManager?.phone}
          </div>
        ) : (
          <ReactSelect
            options={flightManagerOptions}
            value={currentValue}
            onChange={handleFlightManagerChange}
            placeholder="בחירה"
            isSearchable={false}
          />
        )}

        {showLogoutButton && (
          <div className="logout-button" onClick={onLogout}>
            <Image src={logOutIcon} alt="logout" />
          </div>
        )}
      </div>
      {!isOtpMode && children}
    </>
  );
}

export default FlightManagerSelector;
